// Row 3 — the Heisig keyword. text-h1 register; capitalized. The noun the
// kanji *is*. Without it, the glyph above is a riddle and the story below has
// no target.
export function MeaningHeadline({ meaning }: { meaning: string }) {
    return (
        <h1 className="text-center font-serif text-h1 text-ink capitalize">
            {meaning}
        </h1>
    )
}
